import { render, staticRenderFns } from "./HomeObserver.vue?vue&type=template&id=aceeb826&"
import script from "./HomeObserver.vue?vue&type=script&lang=js&"
export * from "./HomeObserver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports